import styles from './FJReportModal.module.less';
import { useState } from 'react';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import classNames from 'classnames';
import FJCheckIcon from '../../../../assets/svg/community/check.svg?react';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJModalClose from '../../FJModalClose/FJModalClose.jsx';

const list = [
    {
        text: 'sexual-content',
    },
    {
        text: 'violent-or-repulsive-content',
    },
    {
        text: 'hateful-or-abusive-content',
    },
    {
        text: 'harassment-or-bullying',
    },
    {
        text: 'harmful-or-dangerous-acts',
    },
    {
        text: 'child-abuse',
    },
    {
        text: 'promote-terrorism',
    },
    {
        text: 'infringe-my-rights',
    },
    {
        text: 'other',
    },
];

function FJReportModal(props) {
    const { onCancel, onSubmit } = props;
    const [activeIndex, setActiveIndex] = useState(-1);
    const [reportContent, setReportContent] = useState('');

    /**
     * @description 键入修改值
     * @param e
     * @private
     */
    const _onChange = e => {
        setReportContent(e.target.value);
    };

    /**
     * @description 点击选项
     * @param index
     * @private
     */
    const _onClick = index => {
        if (activeIndex === index) {
            return;
        }
        setActiveIndex(index);
    };

    /**
     * @description 点击提交举报
     * @private
     */
    const _onSubmit = () => {
        onSubmit(activeIndex, reportContent);
    };

    /**
     * @description 渲染页面
     * @returns {*[]}
     * @private
     */
    const _getComp = () => {
        let listComp = [];
        list.forEach((item, index) => {
            const isActive = activeIndex === index;
            listComp.push(
                <li
                    key={index}
                    className={classNames(styles.item, isActive ? styles.check_active : null)}
                    onClick={() => {
                        _onClick(index);
                    }}
                >
                    <div className={styles.check} />
                    <div className={styles.text}>{FJLocalStore._(item.text)}</div>
                </li>,
            );
        });
        return listComp;
    };

    return (
        <div className={styles.box}>
            <FJModalClose onClick={onCancel} className={styles.close} />
            <div className={styles.title}>{FJLocalStore._('report')}</div>

            <ul className={styles.check_box}>{_getComp()}</ul>

            <div className={styles.area}>
                <textarea
                    placeholder={FJLocalStore._('add-a-detailed-description-here')}
                    maxLength='1000'
                    value={reportContent}
                    onChange={_onChange}
                />
            </div>

            <div className={styles.footer}>
                <FJButton text={FJLocalStore._('cancel')} className={styles.btn} onClick={onCancel} />

                <FJButton
                    text={FJLocalStore._('report')}
                    className={styles.btn}
                    type='gradient'
                    onClick={_onSubmit}
                    disabled={activeIndex === -1}
                />
            </div>
        </div>
    );
}

export default FJReportModal;
